export const eduauraaAppLink = (link: string) => {
  if (window?.zee5) {
    window.zee5.openZee5AppDeepLinkRecievedFromEduauraaWebView(
      `https://www.zee5.com${link}`
    );
  }
};
